import * as actionTypes from '../types/so';

export function getSO(payload) {
  return {
    type: actionTypes.GET_SO,
    payload
  };
}
export function getSOSuccess(payload) {
  return {
    type: actionTypes.GET_SO_SUCCESS,
    payload
  };
}
export function getSOFail(payload) {
  return {
    type: actionTypes.GET_SO_FAIL,
    payload
  };
}

export function getSORP(payload) {
  return {
    type: actionTypes.GET_SO_RP,
    payload
  };
}

export function getSORPSuccess(payload) {
  return {
    type: actionTypes.GET_SO_RP_SUCCESS,
    payload
  };
}

export function getSORPFail(payload) {
  return {
    type: actionTypes.GET_SO_RP_FAIL,
    payload
  };
}

export function rebindSORP(payload) {
  return {
    type: actionTypes.REBIND_SO_RP,
    payload
  };
}

export function rebindSORPSuccess(payload) {
  return {
    type: actionTypes.REBIND_SO_RP_SUCCESS,
    payload
  };
}

export function rebindSORPFail(payload) {
  return {
    type: actionTypes.REBIND_SO_RP_FAIL,
    payload
  };
}

export function getSOForRebind(payload) {
  return {
    type: actionTypes.GET_SO_FOR_REBIND,
    payload
  };
}

export function getSOForRebindSuccess(payload) {
  return {
    type: actionTypes.GET_SO_FOR_REBIND_SUCCESS,
    payload
  };
}

export function getSOForRebindFail(payload) {
  return {
    type: actionTypes.GET_SO_FOR_REBIND_FAIL,
    payload
  };
}
